export const CONDITION_CHANGE = 'change:condition';
export const CONDITIONS_HIERARCHIES_CHANGE = 'change:conditions-hierarchies';
export const CHANGED = 'changed';
export const APPLY_FILTERS = 'apply-filters';
export const FILTERS_APPLIED = 'filters-applied';
